import { Center } from '@/types/models'

const getCenterImageUrl = (center: Center) => {
  const baseUrl =
    'https://res.cloudinary.com/rehabpath/image/upload/e_gen_restore/c_fill,q_15,w_640,h_400/f_auto/'
  return center.featured_image
    ? `${baseUrl}${center.featured_image.split('/').pop()}`
    : `${baseUrl}${center.slug}-thumb`
}

export default getCenterImageUrl
